import { memo } from 'react';

import SortDescendingIconSVG from '@/assets/sort-descending-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISortDescendingIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SortDescendingIconSVG} {...props} />
);

export const SortDescendingIcon = memo(ISortDescendingIcon) as typeof ISortDescendingIcon;
